import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

// Eventos de autenticación
export const logLogin = (method) => {
  logEvent(analytics, 'login', {
    method: method // 'google'
  });
};

export const logSignUp = (method) => {
  logEvent(analytics, 'sign_up', {
    method: method // 'google'
  });
};

// Eventos del chatbot
export const logMessageSent = () => {
  logEvent(analytics, 'message_sent');
};

export const logPropertySearch = (location, propertyType) => {
  logEvent(analytics, 'property_search', {
    location: location,
    property_type: propertyType
  });
};

export const logPropertyView = (propertyId) => {
  logEvent(analytics, 'property_view', {
    property_id: propertyId
  });
};

// Eventos de navegación
export const logPageView = (pageName) => {
  logEvent(analytics, 'page_view', {
    page_name: pageName
  });
};

export default analytics;
